

export default {

  register: '/api/account/register',
  resendRegisterActivationEmail: '/api/account/resendRegisterActivationEmail',

  verifyGDPRTerms: '/api/account/verifyGDPRTerms',
  acceptGDPRTerms: '/api/account/acceptGDPRTerms'

}



// WEBPACK FOOTER //
// ./src/urls/accountUrls.js